export default "__VITE_ASSET__CJvuZ0cK__"